import axios from "axios";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

export interface CacheEntry {
    _id: string;
    key: string;
    size: number; // BSON bytes
    expiresAt?: string;
    createdAt?: string;
    updatedAt?: string;
    expired: boolean;
}

export interface CachePrefix {
    prefix: string;
    count: number;
    size: number;
}

export interface CacheListResponse {
    items: CacheEntry[];
    total: number;
    totalSize: number;
    page: number;
    totalPages: number;
    prefixes: CachePrefix[];
    storage: { count: number; size: number; storageSize: number; indexSize: number } | null;
}

export interface CacheListParams {
    page: number;
    limit: number;
    q?: string;
    prefix?: string;
    sort?: "recent" | "size";
}

export interface CacheEntryPreview {
    _id: string;
    key: string;
    preview: string;
    truncated: boolean;
    length: number;
}

export const getCacheEntries = async (params: CacheListParams): Promise<CacheListResponse> => {
    const res = await axios.get("/admin/cache", { ...config(), params });
    return res.data;
};

export const getCacheEntry = async (id: string): Promise<CacheEntryPreview> => {
    const res = await axios.get(`/admin/cache/${id}`, config());
    return res.data;
};

export const deleteCacheEntry = async (id: string): Promise<void> => {
    await axios.delete(`/admin/cache/${id}`, config());
};

// Purges every entry matching the filters; no filter = the whole cache.
export const purgeCache = async (filters: { q?: string; prefix?: string }): Promise<number> => {
    const res = await axios.delete("/admin/cache", { ...config(), params: filters });
    return res.data.deleted;
};
